import { useEffect, useRef, useState } from 'react';
import classnames from 'classnames';
import { IMaskInput } from 'react-imask';
import IconClear from '@scramble/design-system/icons/x-close.svg';
import { CURRENCY } from '@scramble/utils';
import { MoneyFieldProps } from './types';
import s from './index.module.scss';

export const MoneyAccentField = ({
  label,
  name,
  value,
  placeholder,
  onChange,
  onClear,
  error,
  description,
  isFloat,
}: MoneyFieldProps) => {
  const [maskedValue, setMaskedValue] = useState(value.toString());
  const internalNumericValue = useRef(Number(value));

  useEffect(() => {
    if (Number(value) !== internalNumericValue.current) {
      internalNumericValue.current = Number(value);
      setMaskedValue(value.toString());
    }
  }, [value]);

  return (
    <div className={s.wrapper}>
      {label && (
        <label htmlFor={name} className={s.label}>
          {label}
        </label>
      )}
      <div className={s.container}>
        <div className={s.currency}>{CURRENCY}</div>
        <IMaskInput
          id={name}
          mask="num"
          blocks={{
            num: {
              mask: Number,
              thousandsSeparator: "'",
              radix: isFloat ? '.' : undefined,
              scale: isFloat ? 2 : 0,
              mapToRadix: [','],
              min: 0,
              max: 9999999,
            },
          }}
          className={classnames(s.input, error && s.input_error, 'money_accent_field__input')}
          value={maskedValue}
          placeholder={placeholder}
          onAccept={(val: string, mask: { unmaskedValue: string }) => {
            setMaskedValue(val);
            internalNumericValue.current = Number(mask.unmaskedValue);
            onChange(mask.unmaskedValue);
          }}
        />

        {onClear && !!value && (
          <button type="button" className={s.btn_clear} onClick={onClear}>
            <img src={IconClear} width={20} height={20} alt="clear" />
          </button>
        )}
      </div>
      {error ? (
        <div className={s.error}>{error}</div>
      ) : (
        description && <div className={s.description}>{description}</div>
      )}
    </div>
  );
};